import { Meta } from '@storybook/addon-docs';
import { ColorsGrid } from '../../components/ColorsGrid';

<Meta title="Tokens/Colors" />

# Colors

Essas são as cores utilizadas no Ignite UI.

<ColorsGrid />